import {
  Block,
  ComponentBlock,
  InstanceBlock,
  isComponentBlock,
  AtLeast,
  ListView,
} from '@basehub/data/replicache/index'
import { TreeManager, TreeNode } from '@basehub/utils/tree/index'
import { idToSourceBlockId } from '@basehub/data/replicache/mutators/repo-space/block/mutators/copy-on-write'

export const getBlockFromColumnId = (
  columnId: Block['id'],
  {
    row,
    treeManager,
  }: {
    row: ComponentBlock | InstanceBlock
    treeManager: TreeManager<Block, NonNullable<unknown>>
  }
) => {
  const nodeFromTemplate = treeManager.getNode(columnId)
  const rowNode = treeManager.getNode(row.id)
  if (!nodeFromTemplate || !rowNode) {
    return {
      node: null,
      block: null,
      nodeFromTemplate: null,
      blockFromTemplate: null,
    }
  }

  if (isComponentBlock(row)) {
    return {
      node: nodeFromTemplate,
      block: nodeFromTemplate.value,
      nodeFromTemplate,
      blockFromTemplate: nodeFromTemplate.value,
    }
  } else {
    let rowChildNode: TreeNode<Block> | null = null
    for (const childId of treeManager.getChildrenKeys(row.id)) {
      const childNode = treeManager.getNode(childId)
      if (
        childNode?.value.instanceChildTarget ===
        idToSourceBlockId(nodeFromTemplate.value)
      ) {
        rowChildNode = childNode
        break
      }
    }

    return {
      node: rowChildNode,
      block: rowChildNode?.value ?? null,
      nodeFromTemplate,
      blockFromTemplate: nodeFromTemplate.value,
    }
  }
}

export const getViewDefaultTitle = (
  view: AtLeast<ListView, 'layout'> | undefined
) => {
  if (!view) return 'Table view'
  return `${view.layout.charAt(0).toUpperCase() + view.layout.slice(1)} view`
}
